import React, { useEffect, useState } from "react";
import "../App.scss";
import "./NewPatient.scss";
import jason from '../assets/images/jason.jpg';
import brian from '../assets/images/brian.jpg';
const AboutUs = () => {
  
  return (
    <div className="pageContainer">
      <div className="pageHeader">
      <div className="h1 hippiBlue" style={{marginBottom:"0.5rem"}}>About Us</div>
      <div className="b1 midGray">VETTA Solutions introduces an inaugural line of wearable devices that not only target the underlying causes of osteoarthritis, but allows each step you take to work for your joint’s health, and not against it</div>
          <div>
            <div className="h1 hippiBlue" style={{margin:"2rem 0 0.5rem 0"}}>Our Story</div>
<div className="b1 midGray">VETTA Solutions is an early spin-off company out of UNC Chapel Hill co-founded by world-renowned experts in biomechanics working toward the future of rehabilitation for knee joint health.

Our debut product is an out-of-the-box wearable sensor and machine learning platform that provides the first opportunity to detect and monitor harmful compressive forces during everyday activities, and a simple user interface that can guide our customers to improved knee joint health. 

Founded with inspiration from 15 years of peer-reviewed, nationally-recognized scientific research, VETTA Solutions is ready to set new standards for rehabilitation for knee joint health.</div>
</div>
<div>
<div className="h1 hippiBlue" style={{margin:"2rem 0 0.5rem 0"}}>Our Mission</div>
<div className="b1 midGray">To shape the future of joint rehabilitation by developing accessible, evidence-based devices to combat musculoskeletal conditions that cause lower extremity joint disease and disability</div>
</div>
<div>
<div className="h1 hippiBlue" style={{margin:"2rem 0 0.5rem 0"}}>Our Team</div>
<div className="row space-between">
  <div className="col centerAlign b1 midGray" style={{flex:1, marginRight:"5rem"}}>
    <div><img src={jason} alt="Jason Franz, PhD"/></div>
    <div>Jason Franz, PhD</div>
    <div>Associate Professor,</div>
    <div className="textCenter"> University of North Carolina at Chapel Hill & North Carolina State Joint Biomedical Engineering</div>
    <div>Rehabilitation Engineering and Technology</div>
  </div>
  <div className="col centerAlign b1 midGray" style={{flex:1}}>
  <div><img src={brian} alt="Brian Pietrosimone, PhD"/></div>
    <div>Brian Pietrosimone, PhD</div>
    <div>Professor,</div>
    <div className="textCenter"> University of North Carolina at Chapel Hill Exercise <br/>and Sports Science</div>
    <div>Osteoarthritis Mechanisms and Treatment</div>
  </div>
</div>
</div>
          </div>
        </div>
  );
};

export default AboutUs;
